import React, { useCallback } from 'react'
import { useLocation } from 'react-router-dom'
import useGetDetails from '../bottomSheet/hooks/useGetDetails'
import InfiniteScroll from 'react-infinite-scroll-component'
import DotsLoading from 'components/loadings/dotsLoading'
import StarIcon from 'assets/images/star/star.svg'
import { BankNameConvertor } from 'utilities/helper/bankNameConvertor'
import { ctxMnp } from 'utilities/helper/moneyPools'
import { ConvertorMiladi } from 'utilities/helper/digitToMonth'

export default function History() {
    const { state } = useLocation()
    const { data, fetchNextPage, isLoading } = useGetDetails(state.id)
    const onWatchEnd = useCallback(() => {
        fetchNextPage()
    }, [fetchNextPage])
    return (
        <div>
            <div className="shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] bg-gradient-to-b from-from-card to-to-card mx-3 my-3 rounded-xl px-4 py-2">
                <div className=" flex justify-between mb-2 mt-3">
                    <img
                        src={BankNameConvertor[state.item.bank_unique_code]}
                        alt="bank"
                    />
                    {state.item.is_default && <img src={StarIcon} alt="star" />}
                </div>
                <div className=" my-4 text-xl text-center text-black">
                    <p dir="ltr">
                        {state.item.card_number
                            ? state.item.card_number
                                  .match(/.{1,4}/g)
                                  ?.join('\xa0\xa0\xa0\xa0')
                            : state.item.iban
                                  .match(/.{1,4}/g)
                                  ?.join('\xa0\xa0\xa0\xa0')}
                    </p>
                </div>
                <div className=" mb-2 flex justify-between">
                    <p>
                        {state.item.owner_first_name}{' '}
                        {state.item.owner_last_name}
                    </p>
                </div>
            </div>
            <div className=" bg-green-main py-2 flex justify-between mx-2 px-3 rounded-md ">
                <p>مجموع واریزها</p>
                <p className=" text-green-1">
                    {data && data?.pages[0].amount_sum.toLocaleString()} تومان
                </p>
            </div>
            <InfiniteScroll
                next={onWatchEnd}
                hasMore={
                    data
                        ? data?.pages[data.pages.length - 1].next
                            ? true
                            : false
                        : false
                }
                dataLength={
                    data ? data.pages.flatMap((x) => x.results).length : 0
                }
                loader={<DotsLoading />}
            >
                <>
                    {!isLoading && data ? (
                        data.pages
                            .flatMap((x) => x.results)
                            .map((item, index) => (
                                <div className=" mx-2 my-2" key={index}>
                                    <div className=" flex justify-between px-3">
                                        <p>
                                            {item.ctx_type === 'mnp'
                                                ? item.moneypool_data &&
                                                  ctxMnp[
                                                      item.moneypool_data.type
                                                  ]
                                                : item.ctx_type === 'ccl'
                                                ? 'پرداخت سهم'
                                                : ''}
                                        </p>
                                        <p className=" text-green-1">
                                            {item.amount.toLocaleString()} تومان
                                        </p>
                                    </div>
                                    <div className="  flex justify-between px-3 my-3 ">
                                        <p>
                                            صندوق{' '}
                                            {item.ctx_type === 'mnp'
                                                ? item.moneypool_data &&
                                                  item.moneypool_data
                                                      .moneypool_name
                                                : item.cycle_data &&
                                                  item.cycle_data.cashbox_name}
                                        </p>
                                        <p>{ConvertorMiladi(item.created)}</p>
                                    </div>
                                    <hr className=" my-2 mx-3" />
                                </div>
                            ))
                    ) : (
                        <DotsLoading />
                    )}
                </>
            </InfiniteScroll>
        </div>
    )
}
